<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;display: flex; align-items: center;"
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto;"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item style="margin-left: -15px;width: 165px">
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次号"
                  ></el-input>
                </el-form-item>
                <el-form-item style="">
                  <el-input v-model="form.sku" placeholder="sku编号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_full_allot"
                    placeholder="是否配齐"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in is_full_allot"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_remark"
                    placeholder="有无备注"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in is_remark"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div style="margin-bottom: 0;">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="is_remark"
              label="有无备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods"
              label="货号/颜色/尺码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="quality_label_num"
              label="分离数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="upself_picking_num"
              label="仓位拣货数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="picking_num"
              label="已拣货数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_num"
              label="所需数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="init_num"
              label="原始数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="full_allot"
              label="是否配齐"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      resData: {},
      form: {
        pagesize: 50,
      },
      is_full_allot: [
        { key: "1", name: "是" },
        { key: "0", name: "否" },
      ],
      is_remark: [
        { key: "1", name: "是" },
        { key: "0", name: "否" },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/WavePickingTempSummary/qlSummaryDetail",
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    defaultDate() {
      let endDate = new Date();
      let endM =
        endDate.getMonth() + 1 < 10
          ? "0" + (endDate.getMonth() + 1)
          : endDate.getMonth() + 1;
      let end =
        endDate.getFullYear() +
        "-" +
        endM +
        "-" +
        endDate.getDate() +
        " 23:59:59";

      let startDate = new Date();
      startDate.setDate(startDate.getDate() - 2);
      let startM =
        startDate.getMonth() + 1 < 10
          ? "0" + (startDate.getMonth() + 1)
          : startDate.getMonth() + 1;
      let start =
        startDate.getFullYear() +
        "-" +
        startM +
        "-" +
        startDate.getDate() +
        " 00:00:00";
      return [start, end];
    },
    closeBox() {
      this.showbox = false;
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (!this.$route.params.id) {
        this.$message.error("url参数错误");
        return false;
      }
      this.form.quality_label_summary_id = this.$route.params.id;
      this.$http.post(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data;
          console.log(this.resData);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      let multipleSelection = [];
      let claims_detail_id = [];
      for (let key in val) {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claims_detail_id[key] = val[key].claims_detail_id;
        }
      }
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claims_detail_id;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then(res => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      var result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
  margin-top: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/QlSummaryDetail.vue